import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiInfo } from 'react-icons/fi';
import { useThemeClasses } from '../hooks/useThemeClasses';
import { getSubscriptionMoraBannerMessage } from '../utils/subscriptionAccess';

/** Mora / acceso bloqueado en navbar. La beta se muestra solo en Inicio y Cuenta. */
export default function SubscriptionStatusBanner({ user, showWhenBlocked = false }) {
  const tc = useThemeClasses();
  const message = getSubscriptionMoraBannerMessage(user, { includeBlocked: showWhenBlocked });
  if (!message) return null;

  const tone = message.tone || 'grace';
  const isInfo = tone === 'info';
  const isGrace = tone === 'grace';
  const shellClass = isInfo
    ? tc.modoOscuro
      ? 'bg-blue-950/90 border-blue-800/80 text-blue-50'
      : 'bg-blue-50 border-blue-200 text-blue-950'
    : isGrace
      ? tc.modoOscuro
        ? 'bg-amber-950/95 border-amber-800/80 text-amber-50'
        : 'bg-amber-50 border-amber-200 text-amber-950'
      : tc.modoOscuro
        ? 'bg-red-950/95 border-red-800/80 text-red-50'
        : 'bg-red-50 border-red-200 text-red-950';
  const iconClass = isInfo
    ? tc.modoOscuro ? 'text-blue-400' : 'text-blue-600'
    : isGrace
      ? tc.modoOscuro ? 'text-amber-400' : 'text-amber-600'
      : tc.modoOscuro ? 'text-red-400' : 'text-red-600';
  const ctaClass = isInfo
    ? tc.modoOscuro
      ? 'bg-[#1F80FF] text-white hover:bg-blue-500'
      : 'bg-[#1F80FF] text-white hover:bg-[#004AAD]'
    : isGrace
      ? tc.modoOscuro
        ? 'bg-amber-500 text-black hover:bg-amber-400'
        : 'bg-amber-600 text-white hover:bg-amber-700'
      : tc.modoOscuro
        ? 'bg-red-500 text-white hover:bg-red-400'
        : 'bg-red-600 text-white hover:bg-red-700';

  const title = tone === 'blocked' ? 'Acceso limitado' : 'Pago pendiente.';
  const ctaLabel = 'Regularizar pago';
  const ctaUrl = '/planes?pago=pendiente';
  const Icon = isInfo ? FiInfo : FiAlertTriangle;

  return (
    <div role="status" className={`border-b ${shellClass} shadow-sm`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-2.5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <div className="flex items-start gap-2.5 min-w-0 flex-1">
          <Icon className={`h-4 w-4 shrink-0 mt-0.5 ${iconClass}`} aria-hidden />
          <p className="text-sm leading-snug">
            <span className="font-semibold">{title}</span>{' '}
            {message.body}
          </p>
        </div>
        <Link
          to={ctaUrl}
          className={`shrink-0 self-start sm:self-center inline-flex items-center justify-center rounded-lg px-3 py-1.5 text-xs font-semibold ${ctaClass}`}
        >
          {ctaLabel}
        </Link>
      </div>
    </div>
  );
}
